(function() {
  'use strict';
  
  // Adapted from: http://www.ng-newsletter.com/posts/d3-on-angular.html
  angular
    .module('plugins.bar-chart')
    .directive('barChart', barChart);
      
  barChart.$inject = ['$log', '$window', 'plugins'];
    
  function barChart($log, $window, plugins) {
    $log = $log.getInstance('barChart');
    
    var directive = {
      link: link,
      restrict: 'EA',
      scope: {
        data: '='
      },
    }
    return directive;
    
    function link(scope, ele, attrs) {
      plugins.loadScript('assets/libs/d3/d3.js', 'd3')
        .then(function(d3) {

          var parentElement = ele[0];
      
          var elementPadding = parseInt(attrs.elementPadding) || 10,
              barHeight = parseInt(attrs.barHeight) || 40,
              barPadding = parseInt(attrs.barPadding) || 40,
              fontSize = parseInt(attrs.fontSize) || 18,
              labelMargin = parseInt(attrs.labelMargin) || 0,
              resultsHidden = attrs.resultsHidden === 'true';
          
          var color = d3.scaleOrdinal([
            '#f44336', '#00BCD4', '#FFC107', '#607D8B', '#673AB7',
            '#2196F3', '#03A9F4', '#3F51B5', '#009688', '#4CAF50',
            '#8BC34A', '#CDDC39', '#FFEB3B', '#E91E63', '#FF9800',
            '#FF5722', '#795548', '#9E9E9E', '#9C27B0'
          ]);

          if (resultsHidden) color = d3.scaleOrdinal(['#eee'])

          var div = d3.select(parentElement)
            .append('div')
            .style('padding', elementPadding + 'px')
            .style('box-sizing', 'border-box');
      
          scope.render = function(data) {
            $log.debug('render');

            // Nothing to render if there's no data
            if (!data) return;

            // Create the bars
            var groups = div
              .style('overflow', 'hidden')
              .selectAll('g')
                .data(data)
              .enter()
              .append('g')

            // Add text for choices
            groups.append('h3')
              .attr('class', 'bar-label')
              .text(function(d) { return d.label + '.'; });

            groups.append('div')
              .attr('class', 'bar-text')
              .text(function(d) { return d.text; });

            // Add rectangles
            var bars = groups
              .append('div')
                .attr('class', 'percentage-bars')
                .style('margin', '4px 0px ' + barPadding + 'px')
                .style('width', '0px')
                .style('height', barHeight + 'px')
                .style('border-radius', '4px')
                .style('background-color', function(d) {
                  return color(d.label);
                })

              // Add pecentage text e.g. (109) 22%
              bars.append('span')
                  .attr('class', 'choice-percentage')
                  .style('position', 'relative')
                  .style('right', '0px')
                  .style('margin', (barHeight-28)/2 + 'px 0px')
                  // 28px above is for text height + top and bottom padding
                  .style('padding', '6px')
                  .style('float', 'right')
                  .style('font-size', '14px')
                  .style('text-align', 'center')
                  .style('white-space', 'nowrap')
                  .text( '0%');

          }

          scope.update = function(data, transitionDuration) {
            $log.debug('update');

            // Nothing to render if there's no data
            if (!data) return;

            var barWidths = [],
                total = 0,
                transitionDuration = transitionDuration || 300;

            var width = d3.select(parentElement)
                  .node().getBoundingClientRect().width;

            var xScale = d3.scaleLinear()
                  .domain([0, d3.max(data, function(d) { return d.value; })])
                  .range([0, width  - 2*elementPadding])

            // Get total number of votes
            data.forEach(function(d) {
              barWidths.push(xScale(d.value));
              total += d.value;
            });

            var bar = div.selectAll('.percentage-bars')
              .data(data)
              .transition()
                .duration(transitionDuration)
                .style('width', function(d, i) {
                  return barWidths[i] + 'px';
                });

            div.selectAll('.choice-percentage')
              .text(function(d, i) {
                if (resultsHidden) return 'Results Hidden'
                else return d.value > 0
                  ? '(' + d.value + ')  ' + Math.round(100*d.value/total) + '%'
                  : '(0) 0%';
              })
              .style('right', function(d, i) {
                return barWidths[i] > (this.offsetWidth)
                // '12' above is for 6px padding either side
                  ? 6 + 'px'
                  : 0 - this.offsetWidth - labelMargin + 'px'
              })

          }
          
          // Initial render
          scope.render(scope.data);
          scope.update(scope.data, 0);

          // We're using pixels, so the sizes need to be recalculated when 
          // the window is resized to remain proportional.
          var onResize = function() {
            scope.update(scope.data);
            scope.$apply();
          }
          angular.element($window).bind('resize', onResize);
          scope.$on('$destroy', function() {
            angular.element($window).unbind('resize', onResize);
          });
      
          // Watch for data changes and update bar sizes
          scope.$watch('data', function(newData, oldData) {
            return scope.update(newData);
          }, true);

        });
      }
      
  }
  
})();